import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SecurityQuestionContentApi } from '@com-delta-idp/mnx-login-ui';
import { OauthAEMConfig } from '@com-delta-idp/mnx-oauth';
import {
  ApiBuilder,
  AppConfigService,
  EXCEPTION_CATEGORY_ENUM,
  EXCEPTION_FILE_NAMES_ENUM,
  ExceptionTrackingService,
  HttpRequestMethods,
  IExceptionMetadata
} from '@com-delta-idp/mnx-utils';
import { Observable, forkJoin, throwError } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { IDP_APP } from '../constants/login-constant';
import { LoginModalContent } from '../models/aem';
import { LoginModalEndpointsKeys } from '../models/login-modal.enum';
import { PingOauthService } from './ping-oauth.service';

@Injectable({
  providedIn: 'root'
})
export class LoginContentService {
  loginModalJson!: Observable<LoginModalContent>;
  addSecurityQuestions!: Observable<SecurityQuestionContentApi>;
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private exceptionTrackingService: ExceptionTrackingService,
    private pingOauthService: PingOauthService
  ) {}

  getAEMContentServiceCall = (): Observable<LoginModalContent> => {
    return new ApiBuilder<undefined, LoginModalContent>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP)
      .endpointKey(LoginModalEndpointsKeys['LOGIN_MODAL_AEM_URL'])
      .method(HttpRequestMethods['GET'])
      .errorHandler(this.handleError.bind(this))
      .create();
  };

  getAEMContent(): Observable<LoginModalContent> {
    if (this.loginModalJson) {
      return this.loginModalJson;
    } else {
      this.loginModalJson = this.getAEMContentServiceCall().pipe(
        shareReplay(1)
      );
      return this.loginModalJson;
    }
  }

  getStaticContentForLoginAuthScreen(): Observable<
    [LoginModalContent, OauthAEMConfig]
  > {
    return forkJoin([
      this.getAEMContent(),
      this.pingOauthService.getAuthConfigContent()
    ]);
  }

  handleError(error: HttpErrorResponse): Observable<never> {
    const exceptionMetadata: IExceptionMetadata = {
      fileName: EXCEPTION_FILE_NAMES_ENUM.LOGIN_CONTENT_SERVICE,
      methodName: '_handleError',
      exceptionCategory: EXCEPTION_CATEGORY_ENUM.API_FAILURE,
      exceptionMessage: error.error
    };
    this.exceptionTrackingService.track(
      `[${IDP_APP}]: ${error.status} : ${error.url}`,
      exceptionMetadata
    );
    return throwError(error);
  }

  getAddSecurityQuestionsServiceCall =
    (): Observable<SecurityQuestionContentApi> => {
      return new ApiBuilder<undefined, SecurityQuestionContentApi>(
        this.http,
        this.appConfig
      )
        .app(IDP_APP)
        .endpointKey(LoginModalEndpointsKeys['ADD_SECURITY_QUESTIONS'])
        .method(HttpRequestMethods['GET'])
        .errorHandler(this.handleError.bind(this))
        .create();
    };

  getAddSecurityQuestionsContent(): Observable<SecurityQuestionContentApi> {
    if (this.addSecurityQuestions) {
      return this.addSecurityQuestions;
    } else {
      this.addSecurityQuestions =
        this.getAddSecurityQuestionsServiceCall().pipe(shareReplay(1));
      return this.addSecurityQuestions;
    }
  }

  getAddSqaContent(): Observable<
    [LoginModalContent, SecurityQuestionContentApi]
  > {
    return forkJoin([
      this.getAEMContent(),
      this.getAddSecurityQuestionsContent()
    ]);
  }
}
